import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    // Always redirect to dashboard - auth check happens in _authenticated layout
    throw redirect({
      to: '/dashboard',
    })
  },
})
